// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"a12a1b2f","453":"94081c3c","796":"c41ccecc"}[chunkId] + ".chunk.js";
};